<template>
  <el-dialog :visible.sync="functionShow" width="40%">
    <template slot="title">
      <el-row :gutter="24" style="margin-right: 20px">
        <el-col :span="7">
          <h2>功能配置</h2>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="success" @click="Allcheck">全选</el-button>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button type="primary" @click="UpdateFuncTempLinkCompany"
            >保存</el-button
          >
        </el-col>
      </el-row>
    </template>
    <el-container style="height: 65vh">
      <div class="mar-top20">
        <el-aside width="100%" class="elAside">
          <div style="margin: 20px">
            <el-input
              id="key"
              placeholder="请输入内容"
              v-model="functionSearch"
              @input="inputChange"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="mar-t80"
              ></el-button>
            </el-input>
          </div>
          <zTree
            style="height: 500px"
            ref="tree"
            :defaultChecked="
              companyfunctionIds != null ? companyfunctionIds : []
            "
            @updateIds="updateIds"
            :treeData="zNodes"
            :item="item"
          ></zTree>
        </el-aside>
      </div>
    </el-container>
  </el-dialog>
</template>
<script>
import { adminRoute, enterpriseRoute, projectRoute } from "@/router";
import zTree from "@/components/compontZtree";
import { GetFunctionTemplate, UpdateFuncTempLinkCompany } from "@/setAxios";
export default {
  name: "",
  props: {},
  components: { zTree },
  data() {
    return {
      functionShow: false,
      functionSearch: "",
      companyid: 0, //企业id/项目id
      xid: 0,
      zNodes: null,
      selectNode: null,
      zTeeObj: null,
      companyfunctionIds: [], //企业的id/企业下的项目
      type: 0, //0企业 1项目
      ids: "",
      item: { name: "fctm02", parentName: "fctm03", id: "fctm01" },
    };
  },
  computed: {},
  methods: {
    inputChange(val) {
      fuzzySearch("fctm01filterId", "#key", null, true);
    },
    // 权限设定
    open() {
      this.zNodes = [];
      // 企管端==给项目设置功能
      if (enterpriseRoute.indexOf(this.$route.name.toLowerCase()) > 0) {
        // 获取该公司的id
        this.companyid = localStorage.pid;
      } else if (adminRoute.indexOf(this.$route.name.toLowerCase()) > 0) {
        // 超管端更新时type的类型
        this.type = 0;
      }
      this.GetCompanyFunctionTemplate();
      // 企管控制
    },
    updateIds(ids) {
      this.ids = ids.join();
    },
    //获取公司功能模块
    GetCompanyFunctionTemplate() {
      let params = {
        companyId: this.companyid,
        xid: this.xid, // 获取该公司的id
      };

      GetFunctionTemplate({ params }).then((res) => {
        if (res.Code > 0) {
          // 企管段显示超管端选中的功能and选中的功能
          if (enterpriseRoute.indexOf(this.$route.name.toLowerCase()) > 0) {
            this.zNodes = res.Data.companyfunctiontemplates;
            this.companyfunctionIds = res.Data.projectfunctiontemplateIds;
          } else {
            // 超管端显示所有的功能and选中的功能
            this.zNodes = res.Data.allfunctiontemplates;
            this.companyfunctionIds = res.Data.companyfunctiontemplateIds;
          }
          this.functionShow = true;
        }
      });
    },
    // 更新企业--0,更新项目--1关联模板
    UpdateFuncTempLinkCompany() {
      let idd = null;
      if (enterpriseRoute.indexOf(this.$route.name.toLowerCase()) > 0) {
        // 更新项目关联模板时获取项目id并将type为1
        this.type = 1;
        idd = this.xid;
      } else {
        // 企业
        this.type = 0;
        idd = this.companyid;
      }
      let params = {
        Id: idd,
        type: this.type,
        tempIds: this.ids,
      };
      UpdateFuncTempLinkCompany(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            message: "更新企业关联模板成功！",
            type: "success",
          });
          this.GetCompanyFunctionTemplate();
        }
      });
    },
    Allcheck() {
      this.$refs.tree.checkAllNodes(true);
    },
  },
  created() {
    // fuzzySearch("", "#key", null, true);
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.elAside {
  height: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}
.mar-top20 {
  width: 100%;
  margin-top: 20px;
}
#PdeptTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}
</style>
